import React from "react";
import { Grid, Layers, Filter, Zap, Upload, Shield, Download, Maximize } from "react-feather";

const FEATURES = [
  { icon: <Grid size={14} />, title: "Analytics Dashboard", desc: "Real-time stats, monthly invoice trends, and status breakdown charts" },
  { icon: <Layers size={14} />, title: "Bulk Actions", desc: "Validate, submit, or delete multiple invoices in a single operation" },
  { icon: <Filter size={14} />, title: "Filters & Sort", desc: "Filter invoices by status, date range, or buyer; sort by ref or date" },
  { icon: <Zap size={14} />, title: "FBR Integration", desc: "Direct connection to FBR PRAL API with sandbox and live environment support" },
  { icon: <Maximize size={14} />, title: "FBR QR Code", desc: "Each submitted invoice carries an FBR-generated QR code for buyer verification" },
  { icon: <Upload size={14} />, title: "Invoice Import", desc: "Bulk upload invoices from Excel; auto-mapped to FBR required fields" },
  { icon: <Download size={14} />, title: "Export with FBR No.", desc: "Export invoices to Excel including the FBR invoice number." },
  { icon: <Shield size={14} />, title: "Audit Logs", desc: "Tamper-evident log of every create, update, validate, and submit action" },
];

const CARD_COLORS = [
  { color: "#2D4F8F", bg: "#EEF2FF" },
  { color: "#059669", bg: "#ECFDF5" },
  { color: "#D97706", bg: "#FFFBEB" },
  { color: "#7C3AED", bg: "#F5F3FF" },
  { color: "#0891B2", bg: "#ECFEFF" },
  { color: "#DC2626", bg: "#FEF2F2" },
  { color: "#065F46", bg: "#ECFDF5" },
  { color: "#92400E", bg: "#FEF3C7" },
];

const FeatureHighlights = ({ onDismiss }) => (
  <div className="feature-highlights-box">
    <div className="feature-highlights-header">
      <div>
        <span className="feature-highlights-badge">What&apos;s New</span>
        <h6 className="feature-highlights-title">Platform Features</h6>
      </div>
      {onDismiss && (
        <button
          className="feature-highlights-close"
          onClick={onDismiss}
          aria-label="Dismiss"
          style={{
            background: "#EF4444",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "26px",
            height: "26px",
            fontSize: "16px",
            lineHeight: 1,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          ×
        </button>
      )}
    </div>
    <ul className="feature-highlights-list">
      {FEATURES.map((f, i) => (
        <li key={i} className="feature-highlights-item">
          <span
            className="feature-highlights-icon"
            style={{ color: CARD_COLORS[i].color, background: CARD_COLORS[i].bg }}
          >
            {f.icon}
          </span>
          <div>
            <strong className="feature-highlights-name">{f.title}</strong>
            <p className="feature-highlights-desc">{f.desc}</p>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

export default FeatureHighlights;
